"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */
/**
  TODO Add commenting
*/
module.exports = function(config, get, post, upload){

	function list(){
		return get("/v2/groupchat/list", {});
	}

	function data(group){
		return get("/v2/groupchat/data", {
			group: group
		});
	}

	function update(group, name, description){
		return post("/v2/groupchat/update", {
			group: group,
			name: name,
			description: description
		});
	}

	function leave(group){
		return post("/v2/groupchat/leave", {
			group: group
		});
	}

	function removeMember(group, contact){
		return post("/v2/groupchat/members/remove", {
			group: group,
			contact: contact
		});
	}

	function remove(group){
		return post("/v2/groupchat/delete", {
			group: group
		});
	}

	function send(group, content){
		return post("/v2/groupchat/send", {
			group: group,
			content: content
		});
	}

	function history(group, page){
		return get("/v2/groupchat/history", {
			page: page,
			group: group
		});
	}

	function add(group, contact){
		return post("/v2/groupchat/members/add", {
			group: group,
			contact: contact
		});
	}

	function create(name, description){
		return post("/v2/groupchat/create", {
			name: name,
			description: description
		});
	}

	function read(group){
		return post("/v2/groupchat/read", {
			group: group
		});
	}

	function sendFile(file, group){
		return upload("/v2/groupchat/send/file", {
			group: group
		}, "file", file);
	}

	return {
		list: list,
		data: data,
		update: update,
		leave: leave,
		remove: remove,
		send: {
			message: send,
			file: sendFile
		},
		history: history,
		create: create,
		read: read,
		members: {
			add: add,
			remove: removeMember
		}
	};
};
